<template>
  <div class="apply-business main-bg">
    <div class="main-wrap">
      <nav-crumb class="crumb-pt"></nav-crumb>
      <el-form :hide-required-asterisk="true" :model="businessForm" :rules="businessRules" ref="businessForm" label-width="100px" class="business-form">
        <div class="base-info part">
          <p class="title-name">基础信息</p>
          <div class="part-top">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="门店名称" prop="shopName">
                  <el-input class="inp-txt" v-model="businessForm.shopName" placeholder="请输入门店名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="负责人姓名" prop="realName">
                  <el-input class="inp-txt" v-model="businessForm.realName" placeholder="请输入负责人姓名"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="身份证号" prop="idCardNo">
                  <el-input class="inp-txt" v-model="businessForm.idCardNo" placeholder="请输入身份证号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属兰花协会" prop="xieHui">
                  <el-input class="inp-txt" v-model="businessForm.xieHui" placeholder="（选填）请输入"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="详细地址" prop="address">
                  <el-input class="inp-txt" v-model="businessForm.address" placeholder="请输入详细地址" @change="changeAddressPos()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="店铺城市" prop="currentCity">
                  <el-cascader
                          ref="cascaderAddr"
                          class="inp-txt"
                          placeholder="请选择地址"
                          v-model="businessForm.currentCity"
                          prop="areaName"
                          :options="cityOptions"
                          @change="handleCityChange">
                  </el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="手机号码" prop="phone">
                  <el-input class="inp-txt" type="tel" v-model="businessForm.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="">
                  <map-content id="address_map" class="store-map" :address="businessForm.address"></map-content>
                </el-form-item>
              </el-col>

            </el-row>
          </div>

        </div>
        <div class="photo-info part mt10">
          <p class="title-name">图片信息</p>
          <div class="part-top">
            <el-form-item label="上传证件">
              <upload-file flag="身份证正面" v-model="businessForm.idCard" :limit="1" />
              <upload-file flag="身份证背面" v-model="businessForm.idCardBlack" :limit="1" />
              <upload-file flag="营业执照" v-model="businessForm.yingyePic" :limit="1" />
            </el-form-item>
            <el-form-item label="上传图片">
              <upload-file flag="店铺图片" v-model="businessForm.dianZhao" :limit="1" />
              <upload-file flag="店内照片" v-model="businessForm.dianNei" :limit="1" />
            </el-form-item>
            <el-form-item>
              <button type="button" class="btn-apply" @click="saveShopSubmit('businessForm')">确认提交</button>
            </el-form-item>
          </div>
        </div>
      </el-form>

    </div>
  </div>
</template>
<script>
    import navCrumb from '../../components/crumb/index'
    import uploadFile from '../../components/uploadFile/index'
    import mapContent from '../../components/map.vue'
    import Rules from '../../utils/rules'
    import CityArea from '../../assets/js/city.json'
    import {getShopExamineInfo,shopSubmit,shopKeepSubmit} from '../../api/shop'
  export default {
      data(){
          return {
              userInfo:JSON.parse(localStorage.getItem('user'))||null,
              dialogImageUrl: '',//显示上传图片
              dialogVisible: false,//隐藏
              businessForm:{
                  shopName:'',//门店名称
                  realName:'',//负责人姓名
                  idCardNo:'',//身份证号
                  xieHui:'',//所属协会
                  storeCity:'',//店铺城市
                  address:'',//详细地址
                  currentCity:'',//选中城市
                  phone:'',//手机号码
                  idCard:'',//身份证图片
                  idCardBlack:'',//身份证背面图图片
                  yingyePic:'',//營業執照图片
                  dianZhao:'',//店招图片
                  dianNei:'',//店内图片
              },
              isKeepSubmit:0,
              cityOptions:[],//城市选择
              businessRules:{
                  shopName:Rules.required('请输入门店名称'),
                  realName:Rules.required('请输入负责人姓名'),
                  idCardNo:Rules.required('请输入身份证号'),
                  address: Rules.required('请输入详细地址'),
                  currentCity: Rules.required('请选择省市区'),
                  phone: Rules.required('请输入手机号码')
              }
          }
      },
      components:{
          navCrumb,
          uploadFile,
          mapContent
      },
      created () {
          this.getShopExamineInfo();
      },
      mounted(){
          this.cityOptions=CityArea.provinces;
      },
      methods:{
          handleCityAreaChange(value){
              console.log(value);
          },
          changeAddressPos(){

          },
          getShopExamineInfo(){
              getShopExamineInfo().then(res=>{
                  if(res.data){
                      this.isKeepSubmit=1;
                      this.businessForm=res.data;
                      this.businessForm.currentCity=[res.data.provinceId,res.data.cityId,res.data.areaId];
                  }
                  console.log(res);
              })
          },
          saveShopSubmit(formName){
              this.$refs[formName].validate((valid) => {
                  if (valid) {
                      let request;
                      const form = JSON.parse(JSON.stringify(this.businessForm));
                      delete form.currentCity;
                      if(this.isKeepSubmit==0){
                          request = shopSubmit(form);
                      }else {
                          request = shopKeepSubmit(form);
                      }
                      request.then(res=>{
                          this.$message({
                              message:res.msg,
                              type:'success'
                          });
                          /*this.$store.dispatch('getMeInfoData');
                          this.$router.push({path:'/business'});*/
                      });
                  } else {
                      console.log('error submit!!');
                      return false;
                  }
              });
          },
          handleCityChange(val){
              if(val.length===3){
                  this.businessForm.provinceId=val[0];
                  this.businessForm.cityId=val[1];
                  this.businessForm.areaId=val[2];
                  let arrText = this.$refs['cascaderAddr'].inputValue.split('/');
                  console.log('this.$refs',arrText);
                  this.businessForm.provinceName=arrText[0].trim();
                  this.businessForm.cityName=arrText[1].trim();
                  this.businessForm.areaName=arrText[2].trim();
              }
          },
      }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/common';
  .crumb-pt{padding:20px 0;}
  .part{
    background-color:#fff;

    .title-name{font-size:14px;color:#222;
      height:54px;
      line-height:54px;
      padding-left:30px;
      font-weight:600;border-bottom:1px dashed #EEEEEE;}
  }
  .part-top{
    padding:20px 80px;
  }
.business-form{
  .inp-txt{width:400px;height:38px;background-color:#FCFCFC}
}
  .store-map{
    width:626px;
    height:288px;
    background-color:$main-color;
  }
  .upload-certificates{
    display: inline-block;
    &+.upload-certificates{margin-left:50px;}
    border:1px dashed #E4E5E5;
    width:200px;
    height:150px;
    text-align: center;
    color:#999999;
    .upload-plus{padding-top:30px;}
    .btn-plus{font-size:60px;color:#c9c9c9;}

  }
  .btn-apply{
    width:170px;
    height:36px;
    background:$main-color;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    font-size:14px;
    color:#fff;
    margin-top:26px;
  }
</style>
<style lang="scss">
  @import '../../assets/css/common';
  .business-form{
    .el-input__inner{background-color:#FCFCFC;border:1px solid #E4E5E5;}
  }
</style>
